
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FinancialAssumptions } from './types';

interface ProfitLossTabProps {
  assumptions: FinancialAssumptions;
  onInputChange: (section: keyof FinancialAssumptions, field: string, value: string | number) => void;
}

export function ProfitLossTab({ assumptions, onInputChange }: ProfitLossTabProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="revenueGrowth">Revenue Growth Rate (%)</Label>
          <Input
            id="revenueGrowth"
            type="number"
            value={assumptions.profitLoss.revenueGrowthRate}
            onChange={(e) => onInputChange('profitLoss', 'revenueGrowthRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="cogsPercentage">Cost of Goods Sold (%)</Label>
          <Input
            id="cogsPercentage"
            type="number"
            value={assumptions.profitLoss.costOfGoodsSoldPercentage}
            onChange={(e) => onInputChange('profitLoss', 'costOfGoodsSoldPercentage', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="opexGrowth">Operating Expense Growth (%)</Label>
          <Input
            id="opexGrowth"
            type="number"
            value={assumptions.profitLoss.operatingExpenseGrowth}
            onChange={(e) => onInputChange('profitLoss', 'operatingExpenseGrowth', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="interestRate">Interest Rate (%)</Label>
          <Input
            id="interestRate"
            type="number"
            value={assumptions.profitLoss.interestRate}
            onChange={(e) => onInputChange('profitLoss', 'interestRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="taxRate">Tax Rate (%)</Label>
          <Input
            id="taxRate"
            type="number"
            value={assumptions.profitLoss.taxRate}
            onChange={(e) => onInputChange('profitLoss', 'taxRate', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="depreciationRate">Depreciation Rate (%)</Label>
          <Input
            id="depreciationRate"
            type="number"
            value={assumptions.profitLoss.depreciationRate}
            onChange={(e) => onInputChange('profitLoss', 'depreciationRate', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
